import React, { useState } from 'react';
import apiClient from '../Api/axiosConfig';
import './Contact.css';

const Contact = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState({ state: 'idle', message: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name || !email || !message) {
      setStatus({ state: 'error', message: 'Kérlek, tölts ki minden mezőt!' });
      return;
    }
    setStatus({ state: 'sending', message: 'Küldés...' });

    try {
      const response = await apiClient.post('/contact/submit', {name,email,message});
      setStatus({ state: 'success', message: response.data.message });
      setName(''); setEmail(''); setMessage('');
    } catch (error) {
      setStatus({ state: 'error', message: `Hiba: ${error.message}` });
    }
  };

  return (
    <div className="contact-container">
      <div className="contact-grid">
        <div className="contact-intro">
          <h1 className="contact-title">AZ ADÁS</h1>
          <p className="contact-subtext">
            A frekvencia tiszta. Ha van mondanivalód, most add le. Minden jel rögzítésre kerül.
          </p>
        </div>
        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="form-row">
            <input type="text" placeholder="Hívójel (Név)" value={name} onChange={e => setName(e.target.value)} required />
            <input type="email" placeholder="Koordináták (E-mail)" value={email} onChange={e => setEmail(e.target.value)} required />
          </div>
          <textarea placeholder="Üzenet..." value={message} onChange={e => setMessage(e.target.value)} required />
          <button type="submit" disabled={status.state === 'sending'}>
            {status.state === 'sending' ? 'Adás folyamatban...' : 'Jelzés küldése'}
          </button>
          {status.state !== 'idle' && (
            <p className={`status-message ${status.state}`}>{status.message}</p>
          )}
        </form>
      </div>
    </div>
  );
};

export default Contact;